import styled from 'styled-components';
export const iconWidth = 20;

export const PlayVideoWrapper = styled.div`
  position: relative;
  margin-top: 10px;
  display: block;
  img {
    border-radius: 3px;
  }
`;

const iconSide = `${iconWidth * 2}px`;

export const PlayVideoIcon = styled.div`
    position: absolute;
    bottom: 10px;
    left: 8px;
    height: ${iconSide};
    width: ${iconSide};
    background-color: rgba(255, 255, 255, 0.7);
    box-shadow: 0 2px 7px 4px rgba(0, 0, 0, 0.26);
    border-radius: 50%;
    svg {
      position: absolute;
      left: 12px;
      top: 10px;
    }
`;

export const VideoTimeWrapper = styled.time`
  position: absolute;
  bottom: 20px;
  right: 8px;
  height: 16px;
  line-height: 13px;
  padding: 1.5px 11px 1.5px 9px;
  box-sizing: border-box;
  border-radius: 5px;
  background-color: rgba(255, 255, 255, 0.75);
  font-family: ProximaNova;
  font-size: 11px;
  font-weight: 600;
  font-family: var(--gameday-primary-font);
`;

